import { Map as ImmutableMap, fromJS } from "immutable";

import { SITE_CONFIG_LOAD } from "flavours/glitch/actions/site_config";

const initialState = ImmutableMap({ loaded: false });

export default function siteConfig(state = initialState, action) {
  switch (action.type) {
    case SITE_CONFIG_LOAD:
      return ImmutableMap(fromJS(action.config)).set("loaded", true);
    default:
      return state;
  }
}
